import React, {useEffect} from 'react';
import {FiMoon, FiSun} from 'react-icons/fi';

const DarkModeToggle = () => {
    const [isDarkMode, setIsDarkMode] = React.useState(() => {
        if (typeof window !== 'undefined') {
            return document.documentElement.classList.contains('dark');
        }
        return false;
    });

    useEffect(() => {
        if (isDarkMode) {
            document.documentElement.classList.add('dark');
            localStorage.setItem('darkMode', 'true');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('darkMode', 'false');
        }
    }, [isDarkMode]);

    // Check localStorage on component mount
    useEffect(() => {
        const darkMode = localStorage.getItem('darkMode') === 'true';
        setIsDarkMode(darkMode);
    }, []);

    return (
        <button
            onClick={() => setIsDarkMode(!isDarkMode)}
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
        >
            {isDarkMode ? <FiSun className="w-[18px] h-[18px] text-yellow-500"/> : <FiMoon className="w-[18px] h-[18px]"/>}
        </button>
    );
};

export default DarkModeToggle;
